import { render } from "./Wallet.vue?vue&type=template&id=15342124"
import script from "./Wallet.vue?vue&type=script&lang=js"
export * from "./Wallet.vue?vue&type=script&lang=js"
script.render = render

export default script